import { useState } from "react";
import { Check, Share2 } from "lucide-react";
import { toast } from "sonner";

export const ShareButton = ({ promptId, color = "#22C55E", testId = "share-btn" }) => {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    if (!promptId) return;
    const url = `${window.location.origin}/p/${promptId}`;
    try {
      if (navigator.share) {
        try {
          await navigator.share({ title: "Guango Tools", text: "Mira este reto:", url });
          return;
        } catch {
          // user cancelled or unsupported — fallback to clipboard
        }
      }
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copiado");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("No se pudo copiar el link.");
    }
  };

  return (
    <button
      data-testid={testId}
      onClick={handleShare}
      disabled={!promptId}
      className="press inline-flex items-center gap-2 border-4 border-[#1a1a1a] rounded-xl px-5 py-3 font-mono text-sm uppercase tracking-wider font-bold shadow-hard-sm disabled:opacity-50"
      style={{ background: copied ? "#22c55e" : color }}
    >
      {copied ? <Check className="w-4 h-4" strokeWidth={3} /> : <Share2 className="w-4 h-4" strokeWidth={3} />}
      {copied ? "copiado" : "compartir"}
    </button>
  );
};

export default ShareButton;
